export default "__VITE_ASSET__ChYl_kku__"